module.exports = __webpack_public_path__ + "img/Front_Addon.73a61e27.jpg";